import {
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderMark,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from '@chakra-ui/react';
import cn from 'classnames/bind';
import React from 'react';

import { PriceFormat } from '@/app/_components/price-format/price-format';

import { InputsSeparator } from '../inputs-separator/inputs-separator';
import { PriceFilterPromo } from '../price-filter-promo/price-filter-promo';
import { PriceInput } from '../price-input/price-input';
import { SectionName } from '../section-name/section-name';

import styles from './price.module.scss';

const cx = cn.bind(styles);

export const Price: React.FC<{
  showInCarFinder?: boolean;
  defaultPriceFilter: { min: number; max: number };
  onChange: (value: { min: number; max: number }) => void;
  currentFilter: { min: number; max: number };
}> = ({ showInCarFinder, defaultPriceFilter, currentFilter, onChange }) => {
  const handleMinValue = (value: number) => {
    if (value > currentFilter.max) {
      onChange({
        max: currentFilter.max,
        min: currentFilter.max,
      });
      return;
    }

    if (value < defaultPriceFilter.min) {
      onChange({
        max: currentFilter.max,
        min: defaultPriceFilter.min,
      });
      return;
    }

    onChange({
      max: currentFilter.max,
      min: value,
    });
  };

  const handleMaxValue = (value: number) => {
    if (value < currentFilter.min) {
      onChange({
        min: currentFilter.min,
        max: currentFilter.min,
      });
      return;
    }

    if (value > defaultPriceFilter.max) {
      onChange({
        min: currentFilter.min,
        max: defaultPriceFilter.max,
      });
      return;
    }

    onChange({
      min: currentFilter.min,
      max: value,
    });
  };

  return (
    <div
      className={cx(styles.priceWrapper, {
        carFinderWrapper: Boolean(showInCarFinder),
      })}
    >
      <div className={styles.partWrapper}>
        <div className={styles.sectionWrapper}>
          <SectionName>Price Range</SectionName>
          <div
            className={cx(styles.rangesWrapper, {
              rangesCarFinderWrapper: showInCarFinder,
            })}
          >
            <PriceInput
              prefix="R"
              value={currentFilter.min}
              onChange={handleMinValue}
              name="minPrice"
              step={5000}
            />
            <InputsSeparator />
            <PriceInput
              prefix="R"
              value={currentFilter.max}
              onChange={handleMaxValue}
              name="maxPrice"
              step={5000}
            />
          </div>
        </div>

        <RangeSlider
          step={10000}
          defaultValue={[defaultPriceFilter.min, defaultPriceFilter.max]}
          min={defaultPriceFilter.min}
          max={defaultPriceFilter.max}
          value={[
            currentFilter.min || defaultPriceFilter.min,
            currentFilter.max || defaultPriceFilter.max,
          ]}
          onChange={([min, max]) => {
            onChange({
              min: min ?? defaultPriceFilter.min,
              max: max ?? defaultPriceFilter.max,
            });
          }}
        >
          <RangeSliderTrack bg="gray.100">
            <RangeSliderFilledTrack bg="black" />
          </RangeSliderTrack>
          <RangeSliderThumb
            boxSize={6}
            index={0}
            borderWidth="1px"
            borderColor="black"
          />
          <RangeSliderThumb
            boxSize={6}
            index={1}
            borderWidth="1px"
            borderColor="black"
          />
          <RangeSliderMark value={defaultPriceFilter.min} textAlign="left">
            <Text className={styles.priceFormatText}>
              <PriceFormat prefix="R" value={defaultPriceFilter.min} />
            </Text>
          </RangeSliderMark>
          <RangeSliderMark
            value={defaultPriceFilter.max}
            textAlign="right"
            width="max-content"
            transform="translateX(-100%)"
          >
            <Text className={styles.priceFormatText}>
              <PriceFormat prefix="R" value={defaultPriceFilter.max} />
            </Text>
          </RangeSliderMark>
        </RangeSlider>
      </div>
      {!showInCarFinder && (
        <div className={styles.partWrapper}>
          <PriceFilterPromo />
        </div>
      )}
    </div>
  );
};
